import { Box, Text } from '@chakra-ui/react';

type GooglePassFieldProps = {
  label?: string | null;
  value?: string | number | null;
  id?: string | null;
  isHighlighted?: boolean;
  color: string;
  labelFontSize?: string;
  valueFontSize?: string;
  mtWhenNoLabel?: string;
  textAlign?: 'left' | 'center' | 'right';
  wordBreak?: string;
  maxWidth?: string;
  hideIdPlaceholder?: boolean;
  valueFontWeight?: string;
};

export const GooglePassField = ({
  label,
  value,
  id,
  isHighlighted = false,
  color,
  labelFontSize = '11px',
  valueFontSize = '13px',
  mtWhenNoLabel = '15px',
  textAlign = 'left',
  wordBreak = 'break-word',
  maxWidth,
  hideIdPlaceholder = false,
  valueFontWeight,
}: GooglePassFieldProps) => {
  const hasLabel = !!label;
  const hasValue = value !== undefined && value !== null && value !== '';
  const showIdPlaceholder = !hideIdPlaceholder && !!id && !hasValue;

  const displayValue =
    showIdPlaceholder ? `<${id}>` : hasValue ? String(value) : '';

  if (!hasLabel && !displayValue && !isHighlighted && !id) return null;

  const isEmpty = !hasLabel && !displayValue;

  return (
    <Box
      position="relative"
      maxWidth={maxWidth || '100%'}
      minHeight={isHighlighted && isEmpty ? '24px' : undefined}
      w={isEmpty ? '120px' : undefined}
      p="4px"
      data-highlighted={isHighlighted || undefined}
    >
      {isHighlighted && (
        <Box
          position="absolute"
          inset={0}
          border="2px solid #FF4935"
          borderRadius="4px"
          pointerEvents="none"
        />
      )}
      {hasLabel && (
        <Text
          fontSize={labelFontSize}
          textStyle="headingFamilyRegularGooglePay"
          textAlign={textAlign}
          color={color}
          whiteSpace="normal"
          wordBreak={wordBreak as any}
          noOfLines={2}
        >
          {label}
        </Text>
      )}

      {displayValue && (
        <Text
          fontSize={valueFontSize}
          textStyle="headingFamilyRegularGooglePay"
          fontWeight={valueFontWeight}
          textAlign={textAlign}
          color={color}
          wordBreak={wordBreak as any}
          mt={!hasLabel ? mtWhenNoLabel : '3px'}
        >
          {displayValue}
        </Text>
      )}
    </Box>
  );
};
